import {
  ClearingSaleBuyerStatus,
  ClearingSaleBuyerStatusOrder,
} from "constants/clearingSaleAttributes";

export const ALL_STATUSES = "ALL_STATUSES";

export type StatusFilterValue = typeof ALL_STATUSES | ClearingSaleBuyerStatus;

export function getStatusFilter(
  value: StatusFilterValue,
): (buyerStatus: ClearingSaleBuyerStatus) => boolean {
  if (value === ALL_STATUSES) {
    return () => true;
  }
  return buyerStatus => buyerStatus === value;
}

// Ordered to match the flow of a sale (Sold -> Partially Paid -> Paid), not enum declaration order.
export const statusFilterValues: readonly StatusFilterValue[] = [
  ALL_STATUSES,
  ...ClearingSaleBuyerStatusOrder,
];
